"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClassUtil_1 = require("../util/ClassUtil");
var PublicKey_1 = require("./PublicKey");
var IdentityKey = (function () {
    function IdentityKey() {
        this.public_key = new PublicKey_1.default();
    }
    IdentityKey.new = function (public_key) {
        var key = ClassUtil_1.default.new_instance(IdentityKey);
        key.public_key = public_key;
        return key;
    };
    IdentityKey.prototype.fingerprint = function () {
        return this.public_key.fingerprint();
    };
    IdentityKey.prototype.encode = function (encoder) {
        encoder.object(1);
        encoder.u8(0);
        return this.public_key.encode(encoder);
    };
    IdentityKey.decode = function (decoder) {
        var public_key = ClassUtil_1.default.new_instance(PublicKey_1.default);
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0:
                    public_key = PublicKey_1.default.decode(decoder);
                    break;
                default:
                    decoder.skip();
            }
        }
        return IdentityKey.new(public_key);
    };
    return IdentityKey;
}());
exports.default = IdentityKey;
//# sourceMappingURL=IdentityKey.js.map


//////////////////
// WEBPACK FOOTER
// ../proteus/dist/keys/IdentityKey.js
// module id = 20
// module chunks = 0 1